const AUTH_STORAGE_KEY = 'shop-auth-user';

export function getStoredUser() {
  try {
    const rawValue = window.localStorage.getItem(AUTH_STORAGE_KEY);
    return rawValue ? JSON.parse(rawValue) : null;
  } catch (_error) {
    return null;
  }
}

export function storeUser(user) {
  if (!user) {
    window.localStorage.removeItem(AUTH_STORAGE_KEY);
    return null;
  }

  window.localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(user));
  return user;
}
